<mat-form-field #formFieldContainer [floatLabel]="!isMobileDetect?'auto':'always' " class="date-time-class">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>
  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <input matInput data-input placeholder="{{ componentDefinition?.label }}"
         [id]="elementName + document.documentId" [name]="componentDefinition?.name"
         [formControl]="formControl"
         [errorStateMatcher]="matcher"/>
  <button type="button" *ngIf="!isMobileDetect" data-toggle matSuffix mat-icon-button
          aria-label="date_range"
          (click)="openCalendar()"
           title="Open Calendar">
    <mat-icon>today</mat-icon>
  </button>

</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
